import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges, } from '@angular/core';
import { Product } from '@spartacus/core';
import { Subscription, combineLatest } from 'rxjs';
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';
import { ProductListItemContextSource, ProductListItemContext } from '@spartacus/storefront';
import { GenProductGridItemComponent } from '../../product-list/product-grid-item/product-grid-item.component';

@Component({
  selector: 'gen-product-carousel-item',
  templateUrl: './product-carousel-item.component.html',
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GenProductGridItemComponent,
  ]
})
export class GenProductCarouselItemComponent implements OnChanges, OnDestroy {
  private subscription = new Subscription();

  @Input() item: Product;
  @Input() gaListName: string;

  tooltipMessage: string;
  phoneOrEmail: string;

  constructor(
    protected productListItemContextSource: ProductListItemContextSource,
    private baseStoreService: GenBaseStoreService,
    private cdr: ChangeDetectorRef
  ) {
    this.subscription.add(
      combineLatest([
        this.baseStoreService.getTooltipMessage(),
        this.baseStoreService.getPhoneNumber(),
      ]).subscribe(([messsage, phoneOrEmail]) => {
        this.tooltipMessage = messsage?.message;
        this.phoneOrEmail = phoneOrEmail?.contactInfo;
        this.cdr.markForCheck();
      })
    );
  }

  ngOnChanges(changes?: SimpleChanges): void {
    if (changes?.item) {
      this.productListItemContextSource.product$.next(this.item);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
